/** Church console route for connecting online giving payment providers. */
export const ONLINE_GIVING_SETTINGS_PATH = '/settings/online-giving';
